module.exports = __webpack_public_path__ + "img/discountCampaignsIcon.2de047.svg";